import { render, staticRenderFns } from "./SysConfigCenter.vue?vue&type=template&id=f375f246&scoped=true&"
import script from "./SysConfigCenter.vue?vue&type=script&lang=js&"
export * from "./SysConfigCenter.vue?vue&type=script&lang=js&"
import style0 from "./SysConfigCenter.vue?vue&type=style&index=0&id=f375f246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f375f246",
  null
  
)

export default component.exports